import React from 'react';
import t from '~t';
import { useDispatch } from 'react-redux';
import { logout } from '~data/actions/user';

import { Item, ItemTitle, ItemIcon, ItemLink, Icon } from '~ui';

export default function SettingsProfileLogoutAll() {
  const dispatch = useDispatch();

  return (
    <>
      <Item>
        <ItemIcon>
          <Icon name='exit' />
        </ItemIcon>
        <ItemTitle>{t.s('logOut')}</ItemTitle>
        <ItemLink onClick={() => dispatch(logout())} />
      </Item>

      <Item>
        <ItemIcon>
          <Icon name='exit' />
        </ItemIcon>
        <ItemTitle>{t.s('logOutOfAllDevices')}</ItemTitle>
        <ItemLink onClick={() => dispatch(logout(true))} />
      </Item>
    </>
  );
}
